
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RankingPage = lazy(() => import('./RankingPage'));
const path = 'reports/ranking';
const RankingRoute: FuseRouteItemType = {
	path: path,
	element: <RankingPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Ranking',
					helpName: 'Ranking'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RankingRoute;
